import { render } from "./TopBannerV2.vue?vue&type=template&id=8e2f76ac"
import script from "./TopBannerV2.vue?vue&type=script&lang=js"
export * from "./TopBannerV2.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src900218826/src/production-ready-serverless-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__